var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfSectionScience(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.713 3.766h8.592a1.133 1.133 0 0 0 0-2.266H5.713a1.133 1.133 0 1 0 0 2.266ZM18.32 16.14l-4.78-7.883V6.302a.885.885 0 1 0-1.771 0v2.387l.814 1.324H7.286l.942-1.572V6.316a.885.885 0 0 0-1.771 0V8.03l-4.788 8.13a1.63 1.63 0 0 0 1.452 2.352h13.754a1.63 1.63 0 0 0 1.445-2.372Z",
    fill: "#68686A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfSectionScience);
export default __webpack_public_path__ + "static/media/pdfSectionScience.d7ba3180f9ed6e94d079bc0635a5ba44.svg";
export { ForwardRef as ReactComponent };